import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { NgModule } from '@angular/core';
import { CountWidgetComponent } from './count-widget/count-widget.component';
import { CommonModule } from '@angular/common';
import { SubjectCountWidgetSettingsComponent } from './subject-count-widget/subject-count-widget-settings/subject-count-widget-settings.component';
import { ValidationErrorsModule } from 'app/components/validation-errors/validation-errors.module';
import { SubjectCountWidgetComponent } from './subject-count-widget/subject-count-widget';
import { TaskCountWidgetComponent } from './task-count-widget/task-count-widget';
import { TaskCountWidgetSettingsComponent } from './task-count-widget/task-count-widget-settings/task-count-widget-settings.component';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { FuseMaterialColorPickerModule } from '@fuse/components';
import { LabelService } from './label.service';
import { ReferralCountWidgetSettingsComponent } from './referral-count-widget/referral-count-widget-settings/referral-count-widget-settings.component';
import { ReferralCountWidgetComponent } from './referral-count-widget/referral-count-widget';
import { SubjectReviewCountWidgetComponent } from './subject-review-count-widget/subject-review-count-widget';
import { SubjectReviewCountWidgetSettingsComponent } from './subject-review-count-widget/subject-review-count-widget-settings/subject-review-count-widget-settings.component';

@NgModule({
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatDialogModule,
        MatToolbarModule,
        MatInputModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule,
        MatTooltipModule,
        FuseWidgetModule,
        FuseSharedModule,
        ValidationErrorsModule,
        PhoenixDirectivesModule,
        FuseMaterialColorPickerModule,
    ],
    declarations: [
        CountWidgetComponent,
        SubjectCountWidgetSettingsComponent,
        ReferralCountWidgetSettingsComponent,
        SubjectCountWidgetComponent,
        ReferralCountWidgetComponent,
        TaskCountWidgetComponent,
        TaskCountWidgetSettingsComponent,
        SubjectReviewCountWidgetComponent,
        SubjectReviewCountWidgetSettingsComponent
    ],
    exports: [],
    providers: [
        LabelService,
    ]
})
export class CountWidgetsModule { }
